"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKpiData = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var converters_1 = require("../../converters");
var utils_1 = require("../utils");
/**
 * @internal
 */
function useKpiData(_a) {
    var _this = this;
    var kpiWidget = _a.kpiWidget, filters = _a.filters, filterContext = _a.filterContext, backend = _a.backend, workspace = _a.workspace;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useKpiData");
    utils_1.workspaceInvariant(effectiveWorkspace, "useKpiData");
    var promise = kpiWidget
        ? function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var allFilters, effectiveFilters, primaryMeasure, comparison, isAllTime, secondaryMeasure, secondaryMeasure;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ts_invariant_1.default(kpiWidget.kpi, "The provided widget is not a KPI widget.");
                        allFilters = filters
                            ? converters_1.filterContextItemsToFiltersForWidget(filters, kpiWidget)
                            : converters_1.filterContextToFiltersForWidget(filterContext, kpiWidget);
                        return [4 /*yield*/, effectiveBackend
                                .workspace(effectiveWorkspace)
                                .dashboards()
                                .getResolvedFiltersForWidget(kpiWidget, allFilters)];
                    case 1:
                        effectiveFilters = (_a.sent());
                        primaryMeasure = sdk_model_1.newMeasure(kpiWidget.kpi.metric);
                        comparison = kpiWidget.kpi.comparisonType;
                        isAllTime = !effectiveFilters ||
                            !effectiveFilters.some(function (filter) { return sdk_model_1.isDateFilter(filter) && !sdk_model_1.isAllTimeDateFilter(filter); });
                        if (comparison === "none" || isAllTime) {
                            return [2 /*return*/, { primaryMeasure: primaryMeasure, effectiveFilters: effectiveFilters, allFilters: allFilters }];
                        }
                        if (comparison === "previousPeriod") {
                            secondaryMeasure = sdk_model_1.newPreviousPeriodMeasure(primaryMeasure, [
                                { dataSet: kpiWidget.dateDataSet, periodsAgo: 1 },
                            ]);
                            return [2 /*return*/, { primaryMeasure: primaryMeasure, secondaryMeasure: secondaryMeasure, effectiveFilters: effectiveFilters, allFilters: allFilters }];
                        }
                        if (!(comparison === "lastYear")) return [3 /*break*/, 3];
                        return [4 /*yield*/, getLastYearComparisonMeasure(effectiveBackend, effectiveWorkspace, primaryMeasure, kpiWidget.dateDataSet)];
                    case 2:
                        secondaryMeasure = _a.sent();
                        return [2 /*return*/, { primaryMeasure: primaryMeasure, secondaryMeasure: secondaryMeasure, effectiveFilters: effectiveFilters, allFilters: allFilters }];
                    case 3:
                        ts_invariant_1.default(false, "Unknown comparison " + comparison);
                        return [2 /*return*/];
                }
            });
        }); }
        : null;
    return sdk_ui_1.useCancelablePromise({ promise: promise }, [
        effectiveBackend,
        effectiveWorkspace,
        filters,
        filterContext,
        kpiWidget,
    ]);
}
exports.useKpiData = useKpiData;
function getLastYearComparisonMeasure(backend, workspace, primaryMeasure, targetDateDataset) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var catalog, dateDatasets, relevantDateDataset, yearAttribute;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, backend.workspace(workspace).catalog().forTypes(["dateDataset"]).load()];
                case 1:
                    catalog = _a.sent();
                    dateDatasets = catalog.dateDatasets();
                    relevantDateDataset = dateDatasets.find(function (dateDataset) {
                        if (sdk_model_1.isUriRef(targetDateDataset)) {
                            return dateDataset.dataSet.uri === targetDateDataset.uri;
                        }
                        else {
                            return dateDataset.dataSet.id === targetDateDataset.identifier;
                        }
                    });
                    yearAttribute = relevantDateDataset.dateAttributes.find(function (dateAttribute) { return dateAttribute.granularity === "GDC.time.year"; });
                    return [2 /*return*/, sdk_model_1.newPopMeasure(primaryMeasure, yearAttribute.attribute.ref)];
            }
        });
    });
}
//# sourceMappingURL=useKpiData.js.map